export default "__VITE_ASSET__B0stH0ty__"